import React from "react";
import { Statistic } from "antd";
import { AdnStar } from "../adnStar/AdnStar";

const AdnSatisfactionLevel = ({
    title,
    value,
    loading = false,
    style
}) => {
    return (
        <>
            <Statistic
                title={title}
                suffix={<AdnStar />}
                value={value}
                loading={loading}
                style={style}
            />
        </>
    );
};

export default AdnSatisfactionLevel;